/* eslint-disable react/prop-types */ // TODO: add props
import cx from 'classnames';
import { IndicatorCell, INDICATOR_TYPES } from '../../../../../components';
import { RowExpansionArrow } from '../../../components/Icons';
import { FillInBlankQuestion } from 'edrolo/domains/exams/components/Question/components/FillInBlankQuestion';
import {
  correctableQuestionPropTypes,
  CorrectableQuestionReview,
} from './CorrectableQuestionReview';
import {
  name,
  selfReflection,
} from '../../../components/TableColumns/TableColumns';

import style from './styles.scss';

const FillInBlankQuestionReview = ({
  question,
  getStudentCourseProgressUrl,
  ...restProps
}) => {
  const expander = {
    id: 'expander',
    Header: '',
    style: { width: '3%' },
    Cell: ({ row }) =>
      row.original.getIn(['response', 'field_responses', 0]) ? (
        <div
          className={cx(style.expanderWidgetContainer, style.fullWidthCell)}
          {...row.getToggleRowExpandedProps()}
        >
          {row.isExpanded ? (
            <RowExpansionArrow expanded />
          ) : (
            <RowExpansionArrow />
          )}
        </div>
      ) : null,
  };

  const studentResponseColumn = {
    id: 'studentResponse',
    Header: 'Student Response',
    style: { width: '30%' },
    accessor: (row) => {
      return {
        response: row.get('response'),
      };
    },

    Cell: ({ cell, row }) => {
      const { response } = cell.value;

      return response && response.get('field_responses').size > 0 ? (
        <div {...row.getToggleRowExpandedProps()}>
          {row.isExpanded ? (
            <div className={cx(style.fullWidthCell, style.responseWrapper)}>
              <FillInBlankQuestion
                question={question}
                response={response}
                isQuestionReview
              />
            </div>
          ) : (
            <div className={style.responseWrapper}>
              <span>View student response</span>
            </div>
          )}
        </div>
      ) : (
        <IndicatorCell
          value={'Not answered'}
          indicatorType={INDICATOR_TYPES.NEUTRAL}
        />
      );
    },

    sortType: (rowA, rowB) => {
      let isAnsweredA = null;
      let isAnsweredB = null;
      const responseA = rowA.original.get('response');
      const responseB = rowB.original.get('response');

      if (responseA && responseA.get('field_responses').size > 0) {
        isAnsweredA = true;
      }
      if (responseB && responseB.get('field_responses').size > 0) {
        isAnsweredB = true;
      }

      const isCorrectSortOrder = [true, null];

      if (
        isCorrectSortOrder.indexOf(isAnsweredA) >
        isCorrectSortOrder.indexOf(isAnsweredB)
      ) {
        return 1;
      }

      return -1;
    },
  };

  return (
    <CorrectableQuestionReview
      question={question}
      nameColumn={{
        ...name(getStudentCourseProgressUrl),
        style: { width: '20%' },
      }}
      studentResponseColumnSpec={studentResponseColumn}
      selfReflectionColumn={{ ...selfReflection, style: { width: '12%' } }}
      expanderColumn={expander}
      checklist
      showChart
      {...restProps}
    />
  );
};

export default FillInBlankQuestionReview;

FillInBlankQuestionReview.propTypes = correctableQuestionPropTypes;
